const SearchMixin = (stateObject, showAllOnEmpty) => {
  return {
    data(){
      return{
        searchKey: '',
      }
    },

    watch:{
      async searchKey(value){
        clearTimeout(this.timeout);
        if(value.length > 1) this.$store.state.loading = true;
        else{
          if(showAllOnEmpty){
            if(value.length == 0) this.$store.dispatch('getSearchedData', {filter: '', stateObject})
          } else this.$store.state.receivedData[stateObject].list = [];
        }
        this.timeout = setTimeout(async () => {
          if(value != '' && value.length > 1) await this.$store.dispatch('getSearchedData', {filter: value, stateObject})
          this.$store.state.loading = false;
        }, 1000);
      },
    }
  }
}

export default SearchMixin;


// WEBPACK FOOTER //
// ./src/mixins/search-mixin.js